
import { defineComponent } from 'vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import SignUpBackground from '@/components/sign-up/SignUpBackground.vue'

export default defineComponent({
  name: 'SignUp',
  components: { SignUpBackground },
  computed: mapState('authModule', ['passwordResetError']),
  created: function() {
    this.resetErrors()
  },
  data: function() {
    return {
      newPassword: null,
      loading: false,
    }
  },
  methods: {
    ...mapActions('authModule', ['finishPasswordReset', 'login']),
    ...mapMutations('authModule', ['resetErrors']),
    async submit() {
      this.loading = true
      try {
        await this.finishPasswordReset({
          newPassword: this.newPassword,
          key: this.$route.params.key,
        })
      } finally {
        this.loading = false
      }
    },
  },
})
